import { FormTab, AutocompleteInput, TextInput, DateInput, BooleanInput, ArrayInput, SimpleFormIterator } from "ra-ui-materialui";
import { useState, useEffect } from "react";
import {
    TabbedForm
} from "react-admin";
import { Typography, Paper, Card } from '@material-ui/core';
import { useFormState } from "react-final-form";
import { required, FormDataConsumer } from "ra-core";
import servicePackagesProvider from '../provider/servicePackages.provider';
import plannedActivitiesProvider from '../provider/plannedActivities.provider';
import AutoCompleteCustom from "../components/AutoCompleteCustom"
import ActivitiesTable from "../components/Planned/ActivitiesTable"
import Spinner from '../components/Spinner';


const diasSemana = [
    { id: 1, name: 'Lunes', isCheck: true },
    { id: 2, name: 'Martes', isCheck: true },
    { id: 3, name: 'Miércoles', isCheck: true },
    { id: 4, name: 'Jueves', isCheck: true },
    { id: 5, name: 'Viernes', isCheck: true },
    { id: 6, name: 'Sabado', isCheck: false },
    { id: 0, name: 'Domingo', isCheck: false }
];
/* 
const validatePlannedActivity = (values) => {
    const errors = {};
    if (!values.serviceTypeId) {
        errors.serviceTypeId = 'Requerido';
    }
    if (!values.activityTypeId) {
        errors.activityTypeId = 'Requerido';
    }
    if (!values.subtypeActivityId) {
        errors.subtypeActivityId = 'Requerido';
    }

    return errors
} */

export const PlannedActivityList = props => {
    const [servicePackage, setServicePackage] = useState([]);
    const [activeSpinner, setActiveSpinner] = useState(false);
    const [showList, setShowList] = useState(false);
    const [plannedActivities, setPlannedActivities] = useState([]);
    const [editingActivity, setEditingActivity] = useState(null);

    const today = new Date().toISOString().split('T')[0];  // Obtener la fecha actual en formato YYYY-MM-DD
    const dateValidation = (value) => {
        if (!value) {
            return 'La fecha es requerida';
        }
        if (new Date(value) < new Date(today)) {
            return 'La fecha debe ser hoy o posterior';
        }
        return undefined; // Sin errores
    };
    useEffect(() => {
        fetchServicePackages();
    }, []);

    const isEditingGroup = editingActivity?.typologyName === 'Grupal';
    const isEditingIndividual = editingActivity?.typologyName === 'Individual';

    const fetchServicePackages = async () => {

        const res = await servicePackagesProvider.getList(null, {
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'Id', order: 'DESC' }
        });

        if (res) {
            setServicePackage(res?.data);
        }
    };



    return (

        <>
            {
                !activeSpinner && !showList && (
                    <TabbedForm
                        toolbar={null}
                        transform={values => {
                            return {
                                dayIds: Object.entries(values.dias || {})
                                    .filter(([key, value]) => value)
                                    .map(([key]) => parseInt(key)),
                                servicePackageId: values.servicePackageId,
                                maxNumberUsers: values.maxNumberUsers,
                                startDate: values.startDate,
                                endDate: values.endDate,
                                contracts: (values.contracts || []).map(c => c.id)
                            };
                        }}
                    >
                        <FormTab label="Planificador">


                            <Paper elevation={3} style={{ padding: '1.5%', width: '98%' }}>
                                <div className="div-planned">
                                    <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Planificación semanal de actividades</span>
                                    <span> Indique los días a planificar:</span>
                                </div>

                                <div className="grid-dos-columnas-sin-fondo">
                                    <div>
                                        <Typography variant="subtitle1" gutterBottom>
                                            Días de la semana
                                        </Typography>
                                        {diasSemana.map(dia => (
                                            <BooleanInput
                                                key={dia.id}
                                                label={dia.name}
                                                source={`dias.${dia.id}`}
                                                defaultValue={dia.isCheck}
                                            />
                                        ))}

                                    </div>
                                    <div>
                                        <div className="new-line-custom">
                                            <AutocompleteInput
                                                label="Paquete de servicio"
                                                source="servicePackageId"
                                                choices={servicePackage}
                                                validate={[]}
                                                optionText={(record) => record ? record?.name : ''}
                                                optionValue="id"
                                                options={{ InputProps: { autoComplete: 'off' } }}
                                                resettable={true}
                                            />
                                            <TextInput
                                                label="Nº máx. usuarios"
                                                source="maxNumberUsers"
                                                type="number"
                                                validate={[required()]}
                                                fullWidth
                                            />
                                        </div >
                                        <div className="new-line-custom">
                                            <DateInput
                                                label="Fecha inicio"
                                                source="startDate"
                                                validate={[required(), dateValidation]}
                                                fullWidth 
                                            />
                                            <DateInput
                                                label="Fecha fin"
                                                source="endDate"
                                                validate={[required(), dateValidation]}
                                                fullWidth 
                                            />
                                        </div >
                                    </div>
                                </div>
                                <PlannedButton setActiveSpinner={setActiveSpinner} setShowList={setShowList} setPlannedActivities={setPlannedActivities} />
                            </Paper>
                        </FormTab>
                        <FormTab label="Contratos" contentClassName="tab-container no-label">
                            <ArrayInput label="Contratos" source="contracts" id="arrayCustomContracts" validate={[required()]} disabled={false}>
                                <SimpleFormIterator disableRemove={false}>
                                    <FormDataConsumer>
                                        {({ scopedFormData, getSource }) => {
                                            const source = getSource('');
                                            const indexMatch = source.match(/\[(\d+)\]/);

                                            const index = indexMatch ? indexMatch[1] : null;

                                            return (
                                                <>
                                                    <AutoCompleteCustom
                                                        type={"CONTRACTS"}
                                                        label={"Contrato"}
                                                        placeholder={"Buscar contrato"}
                                                        disabled={false}
                                                        data={scopedFormData}
                                                        index={index}
                                                        requiredInput={true}
                                                        {...props} />
                                                </>
                                            );
                                        }}
                                    </FormDataConsumer>
                                </SimpleFormIterator>
                            </ArrayInput>

                            <TextInput style={{ display: 'none' }} source="contractsValidation" />
                        </FormTab>


                    </TabbedForm>
                )
            }
            {!activeSpinner && showList && plannedActivities && (!editingActivity || !isEditingGroup) && (

                <ActivitiesTable
                    props={props}
                    isGroup={false}
                    nameCSV={"PropuestasIndividuales"}
                    editingActivity={editingActivity}
                    setEditingActivity={setEditingActivity}
                    plannedActivities={plannedActivities} />
            )
            }
            <br></br>
            {!activeSpinner && showList && plannedActivities && (!editingActivity || !isEditingIndividual) && (

                <ActivitiesTable
                    props={props}
                    isGroup={true}
                    nameCSV={"PropuestasGrupales"}
                    editingActivity={editingActivity}
                    setEditingActivity={setEditingActivity}
                    plannedActivities={plannedActivities} />
            )
            }
            {
                activeSpinner && !showList && (
                    <Spinner fullscreen />
                )
            }
        </>

    )
}


const PlannedButton = (props) => {
    const { setActiveSpinner, setShowList, setPlannedActivities } = props;
    const { values, invalid } = useFormState();  // invalid indica si el formulario tiene campos no válidos

    const fetchPlannedActivities = async (data) => {
        const res = await plannedActivitiesProvider.initialProcess(data);
        if (res) {
            setTimeout(() => {
                setActiveSpinner(false);
                setPlannedActivities(res?.data);
                setShowList(true);
            }, 3000);
        }
    };

    const handleData = () => {

        if (isFormValid) {
            setActiveSpinner(true);
            const dto = {
                dayIds: Object.entries(values.dias || {})
                    .filter(([key, value]) => value)
                    .map(([key]) => parseInt(key)),
                servicePackageId: values.servicePackageId,
                maxNumberUsers: values.maxNumberUsers,
                startDate: values.startDate,
                endDate: values.endDate,
                contracts: (values.contracts || []).map(c => c.id),
            };
            fetchPlannedActivities(dto);
        }

    };

    const isFormValid = !invalid;  // Si el formulario tiene algún campo inválido, deshabilitamos el botón

    return (
        <div style={{ justifyItems: 'center' }}>
            <Card
                className={isFormValid ? "button-planned" : "button-planned-disabled"}
                onClick={handleData}
                //style={{ cursor: isFormValid ? 'pointer' : 'not-allowed' }}
                disabled={!isFormValid}  // Deshabilitar si el formulario no es válido
            >
                <Typography style={{ fontSize: "1.2rem" }} align="center">
                    Planificar
                </Typography>
            </Card>
        </div>
    );
};